import { useContext } from "react";
import { Col, Row } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import "./style.css";

//Common
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import DisplayData from "../common/DisplayData/DisplayData";
import AddressData from "../common/DisplayData/AddressData";
//App
import { OrganizationViewProps } from "../../types/organization";
import UsersContainer from "../Users/UsersContainer";
import useOrganizationStyles from "./styles";
import { OrganizationViewContext } from "./OrganizationContainer";
import stateApi from "../../app/model/api/stateApi";
import { queryKeys } from "./constants";
import { EMPTY_GUID } from "../../utility/constants";
import CampaignsContainer from "../Campaign/CampaignContainer";
import EmployeeContainer from "../Employee/EmployeeContainer";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { getFormattedPhone } from "../../utility/helpers";
const OrganizationView = (props: OrganizationViewProps) => {
  const { onClose, editAction } = props;
  const organizationContext = useContext(OrganizationViewContext);
  const organizationStyles = useOrganizationStyles();
  const organization = organizationContext?.data;

  const stateQuery = useQuery({
    queryKey: [queryKeys.getState, organization?.stateId],
    queryFn: () => stateApi.get(organization?.stateId ?? EMPTY_GUID),
    enabled: organization?.stateId !== null,
  });

  return (
    <>
      <div style={organizationStyles.organizationContainer}>
        <FormHeader
          title={organization?.name!}
          chipLabel={organization?.isActive ? "Active" : "Inactive"}
          onClose={onClose}
          editActionHandler={editAction}
          formClassName={"pb-0"}
        />
        <Row style={organizationStyles.organizationDetailsContainer}>
          <Col sm={12} md={12} lg={6} xl={6}>
            {organization && (
              <AddressData
                text="Address"
                AddressLine1={organization?.addressLine1}
                AddressLine2={organization?.addressLine2}
                City={organization?.city}
                State={stateQuery?.data?.result?.abbreviation}
                ZipCode={organization?.zipCode}
              />
            )}
          </Col>
          <Col sm={12} md={12} lg={6} xl={6}>
            <DisplayData
              text="Website Url"
              importedData={organization?.websiteUrl}
            />
            <DisplayData
              text="Main Phone"
              importedData={getFormattedPhone(organization?.mainPhone)}
            ></DisplayData>
            <DisplayData
              text="Fax"
              importedData={organization?.fax}
            ></DisplayData>
          </Col>
        </Row>
        <Row style={organizationStyles.organizationDetailsContainer}>
          <Col sm={12} md={12} lg={6} xl={6}>
            {organization?.contactName && (
              <DisplayData
                text="Contact Name"
                importedData={organization?.contactName}
              />
            )}
            {organization?.contactPhone && (
              <DisplayData
                text="Contact Phone"
                importedData={getFormattedPhone(organization?.contactPhone)}
              ></DisplayData>
            )}
            {organization?.contactEmail && (
              <DisplayData
                text="Contact Email"
                importedData={organization?.contactEmail}
              ></DisplayData>
            )}
          </Col>
        </Row>
      </div>

      {organization != null && organization.id != null && (
        <div id="org-tabs-container" className="ms-2 mt-3">
          <Tab.Container
            id="organization-tabs"
            defaultActiveKey="campaign-panel"
          >
            <Nav variant="underline" className="flex-row mb-4">
              <Nav.Item className="pe-3 border-end org-nav-item">
                <Nav.Link
                  eventKey="campaign-panel"
                  style={organizationStyles.tabItem}
                >
                  Campaigns
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="pe-3 border-end org-nav-item">
                <Nav.Link
                  eventKey="employee-panel"
                  style={organizationStyles.tabItem}
                >
                  Employees
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="org-nav-item">
                <Nav.Link
                  eventKey="user-panel"
                  style={organizationStyles.tabItem}
                >
                  Users
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="m-3">
              <Tab.Pane eventKey="campaign-panel">
                <CampaignsContainer fullscreen={true} />
              </Tab.Pane>
              <Tab.Pane eventKey="employee-panel">
                <EmployeeContainer fullscreen={true} />
              </Tab.Pane>
              <Tab.Pane eventKey="user-panel">
                <UsersContainer
                  organizationId={organization.id}
                  fullscreen={true}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      )}
    </>
  );
};

export default OrganizationView;
